<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
    <div class="form-group" [formGroup]="form">
      <app-action-alert controlName="mentationScore" [alerts]="item!.actionAlerts" [form]="form"></app-action-alert>
        <app-unit-quantity label="Mentation Score" unitLabel="ml/dL" placeholder="Value" inputMode="numeric" formControlName="mentationScore"></app-unit-quantity>
    </div>
    <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
  </div>
</app-action-form>

